import * as React from 'react';
import { connect } from 'react-redux';

// Components
import ButtonLink from 'components/ButtonLink';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

interface OwnProps {
    timesheetId: number;
}

interface DispatchProps {
    updateQueryString: Function;
}

export interface Props extends OwnProps, DispatchProps {}

export class TimesheetDeleteLink extends React.PureComponent<Props> {
    public handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.stopPropagation();
        const { timesheetId } = this.props;
        this.props.updateQueryString({
            selectedTimesheet: timesheetId,
            timesheetDeleteModal: true
        });
    };

    public render(): JSX.Element {
        return <ButtonLink onClick={this.handleClick}>Delete</ButtonLink>;
    }
}

export default connect<{}, DispatchProps, OwnProps>(
    null,
    { updateQueryString }
)(TimesheetDeleteLink);
